import React, { FunctionComponent } from 'react';
import { usePageMeta } from '../../hooks';
import PageAlert from '../PageAlert/PageAlert';
import '@justgiving/alert/src/Alert.scss';

export const PageAlertOnlyWrapper: FunctionComponent = ({ children }) => {
  const { displayAlertOnly } = usePageMeta();
  return displayAlertOnly ? <PageAlert /> : <>{children}</>;
};
